import React, { useState } from "react";
import "../css/status-filters.scss";
import { status_of_jobsheets } from "../popData";

// Paid status filters need to be Booleans to be backward compatible
let paidStatusFilters = [
  { label: "All", value: "all" },
  { label: "Paid", value: true },
  { label: "Unpaid", value: false },
  { label: "Sub", value: "sub" },
];

function processPaidStatus(status = "all") {
  // Determine paid status label
  let result = paidStatusFilters.find((f) => {
    return String(f.value) === String(status);
  });

  if (!result) return "All";

  return result?.label;
}

const StatusFilters = (props) => {
  let { options, setOptions, primaryType } = props;
  const [jStatus, setJStatus] = useState(
    window?.sessionStorage?.getItem(`${primaryType}_jStatus`) || "all"
  );

  const [paidStatus, setPaidStatus] = useState(
    String(window?.sessionStorage?.getItem(`${primaryType}_statusFilter`)) || "all"
  );

  let paidStatusLabel = processPaidStatus(paidStatus);

  function handleStatusChange(e) {
    // window?.sessionStorage?.setItem("jobsheets_jStatus", `${e.target.value}`);
    window.sessionStorage.setItem(`${primaryType}_jStatus`, e.target.value);
    setJStatus(e.target.value);

    setOptions({ ...options, jobStatusFilter: e.target.value });
  }

  function cyclePaidStatus() {
    setPaidStatus((prev) => {
      let index = paidStatusFilters.findIndex((f) => String(f.value) === String(prev));

      // If no filter is defined, use "all" filter as starting point
      if (index < 0) index = 0;

      // Determine what the index of the next status filter should be
      let nextIndex = index + 1;
      nextIndex = nextIndex === 4 ? 0 : nextIndex;
      let result = paidStatusFilters[nextIndex];

      // Save to session storage
      window.sessionStorage.setItem(`${primaryType}_statusFilter`, result.value);

      // Save to filter options to actually apply filter
      setOptions({ ...options, statusFilter: result.value });

      // Save to local state
      return result.value;
    });
  }

  return (
    <div className="status-filter-controls">
      {/* Job status filters >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
      <label
        style={jStatus === "all" ? { background: "#f4511e" } : { color: "white" }}
        className="form-control"
      >
        <input onChange={handleStatusChange} type="radio" id={"all"} name="job_status" value={"all"} />
        All{" "}
      </label>

      {status_of_jobsheets.map(({ key, name, value }) => {
        return (
          <label
            style={jStatus === key ? { background: "#f4511e" } : { color: "white" }}
            key={key}
            className="form-control"
          >
            <input onChange={handleStatusChange} type="radio" id={key} name="job_status" value={key} />
            {name}
          </label>
        );
      })}

      {/* Job Status Filter <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}

      {/* Paid Status Filter >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
      <button className="form-control filter-button" onClick={cyclePaidStatus}>
        {paidStatusLabel}
      </button>
      {/* Paid Status Filter <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
    </div>
  );
};

export default React.memo(StatusFilters);
